// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  // serverUrl: 'http://localhost:1337/api',
  serverUrl: 'https://api.theportraitenterprise.com/api',
  appUrl: 'https://www.tryion.shop',
  appImageUrl: 'https://www.tryion.shop/assets/imgs/ionshop.png',
  // appUrl: 'https://theportraitenterprise.com',
  // appImageUrl: 'https://theportraitenterprise.com/assets/imgs/ionshop.png',
  appId: 'myAppId',
  fbId: 'YOUR_FACEBOOK_APP_ID',
  //stripePublicKey: 'pk_test_51LFZjESBmdmZPU8M7ZGQCpGn6CKJslhJq0mVgScFqmACEtep2XEGdM3u5oURPjuumuoA2U5sQFS5rNI6dxCqMTDZ00mjJDOGRR',
  stripePublicKey: 'pk_live_51LcNO5SIzIlIWJt9khI3EHCVSjOLPcxb6XxXkqLPU50j42sIbzkZbmzlBvtpmKAtmrq83UDcAakpi1mFr7moW9S200t5m1Rmxi',
  androidHeaderColor: '#222428',
  defaultLang: 'en',
  googleClientId: 'xxxxxxxxxxxxxxxxxxxxxxxxxx.apps.googleusercontent.com',
  currency: {
    code: 'INR',
    display: 'symbol',
    digitsInfo: '1.2-2',
  },
  oneSignal: {
    appId: 'YOUR_ONESIGNAL_APP_ID',
  },
  // razorpay integration
  razorpay: {
    // key_id: 'rzp_test_63JXt0HnCH9gmv',
    // key_secret: '9GVJRnP1mYQ1tbLDzy58zLPn',
    key_id: 'rzp_live_y0AnnVexdFn9UJ',
    key_secret: 'A9YdGDS0eaBX8vf6EVm8k96j',
  }

};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
